'use client'

import * as React from 'react'
import { Link } from '@repo/web-ui/components/link'
import { tw } from 'utils/classnames'

export interface LinkButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  text?: React.ReactNode
  icon?: React.ReactNode
  prefetch?: boolean
  component?: 'Link' | 'a'
  className?: string
  color?: 'primary' | 'secondary' | 'tertiary'
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  text,
  icon,
  className,
  prefetch = false,
  component = 'a',
  color = 'primary',
  href,
  ...rest
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href?.startsWith('#')) {
      e.preventDefault()
      const targetElement = document.querySelector(href)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <Link
      href={href}
      onClick={handleClick}
      className={tw(
        'text-14 inline-flex items-center justify-center rounded px-6 py-3 font-bold uppercase leading-4 transition-[background-color]',
        color === 'primary' && 'text-cf-white bg-[#60B26A] hover:bg-[#00753D]',
        color === 'secondary' && 'text-cf-white bg-[#493675] hover:bg-[#261D36]',
        color === 'tertiary' && 'bg-[#E5DEF5] text-[#493675] hover:bg-[#D6CAFD]',
        className,
      )}
      component={component}
      prefetch={prefetch}
      {...rest}
    >
      {icon ? <span className="mr-2">{icon}</span> : null}
      {text}
    </Link>
  )
}
